









































































































































































































































































































































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
//import App from "@/components/Global/GetAppData"; //缓存接口
import Enum from "@/components/Global/enumerate"; //全局常量
import Bus from "@/JS/Bus";
import { WxGroup } from "@/Entity"; //全局常量

import { log } from "util";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
@Component({
  components: {}
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Provide()
  private scrollHeight = 600; //当前高度
  @Prop()
  private AddaccountForm: WxGroup | any; //定义数据在WxGroup里
  private optionTagsList: any = []; //加载分组
  private AreaList: any = []; //省份和城市数据
  private providetype: any = []; //省份列表
  private citytype: any = []; //城市列表
  private SetSendDateShow: boolean = true; //显示选择
  private ImportFansDialog: boolean = false; //导入粉丝列表
  private SelectFansDialog: boolean = false; //选择粉丝列表
  private pageSize = 10; //每页的数据条数
  private currentPage = 1; // 默认第一页
  private inboxTabData: any = [];
  private paginationTotal: number = 0;
  private replyTotal: number = 0;
  private replyList: any = [];
  private FindFans: any = []; //查询粉丝条件
  private FindFansData: any = []; //查询粉丝结果
  private SelectFindFansData: any = []; //查询粉丝选中结果
  private ReplyTextListData: any = []; //回复关键词文本
  private ReplyImageListData: any = []; //回复关键词图片列表
  private ReplyGraphicListData: any = []; //回复关键词图文列表
  private ReplyVoiceListData: any = []; //多媒体关键词列表
  private GetAppData: any = []; //取应用号信息
  private loadingText = "数据正在提交中，请稍后.....";
  private loading = false;
  private loadingTwo = false;
  private search: string = "";
  //查看视频
  private viewVideo: boolean = false;
  private VoiceTitle: string = "";
  private VoiceLink: string = "";
  //查看图片相关
  private viewImage = false;
  private picture = {
    url: "",
    height: ""
  };

  //切换类型
  TypeNameChange() {
    if (this.AddaccountForm.TypeName == "-1") {
      this.AddaccountForm.TypeName = undefined;
    }
  }
  //审核状态
  formatReview(row: any, column: any) {
    switch (row.Review) {
      case 1:
        return "通过";
      case 0:
        return "审核中";
    }
  }
  //选择类型

  private MsgTypeList: any = [
    { label: "关键词", value: 99 },
    { label: "文本消息", value: 1 },
    { label: "图片消息", value: 2 },
    { label: "图文消息", value: 3 },
    { label: "语音消息", value: 4 }
    //{ label: "视频消息", value: 5 },
    //{ label: "音乐消息", value: 6 }
    //{ label: "公众号素材", value: 10 }
  ];
  @Provide()
  //验证数据
  data() {
    //验证必填字段
    return {
      rules: {
        Title: [
          { required: true, message: "请输入关键词", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        SetSendDate: [
          { required: true, message: "请输入发送时间", trigger: "blur" }
        ],
        MsgType: [
          { required: true, message: "请选择消息类型", trigger: "change" }
        ],
        SendType: [
          { required: true, message: "请选择消息类型", trigger: "change" }
        ],
        MsgId: [{ required: true, message: "请选择消息", trigger: "change" }]
      }
    };
  }
  //查看图片
  onViewImage(imageUrl: string) {
    if (imageUrl) {
      this.viewImage = true;
      var img_url = imageUrl;
      var img = new Image();
      img.src = img_url;
      this.picture.height = Math.ceil((img.height / img.width) * 570) + "px";
      this.picture.url = imageUrl;
    }
  }
  //素材类型
  formatNature(row: any, column: any) {
    if (row.Nature == `1`) {
      return `永久素材`;
    } else {
      return `临时素材`;
    }
  }
  //格式化匹配度类型
  formatType(row: any, column: any) {
    switch (row.Type) {
      case 0:
        return "包含匹配";
      case 1:
        return "完全匹配";
      default:
        return "";
    }
  }
  //加载分组
  async GetSarchTagsAsync() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "Aid",
            Value: AppAccount.Aid
          }
        ]
      };
      var res: any = await httpApi.SarchTags(params);
      if (res.ErrorCode == 0) {
        var that = this;
        var temp = res.output[0].value;
        temp.forEach(function(v: any, i: any) {
          that.optionTagsList.push({
            value: v.WxId,
            label: v.WxName + "(" + v.fansNum + ")"
          });
        });
        //  this.optionTagsList = res.output[0].value;
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //同步标签
  async FansSyncTags() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      this.loadingText = "数据正在同步交中，请稍后.....";
      let params: any = {
        Input: [
          {
            Name: "aid",
            Value: AppAccount.Aid
          }
        ]
      };
      var res: any = await httpApi.FansSyncTags(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        this.$message.success("同步标签成功");
        this.GetSarchTagsAsync();
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  ///同步微信应用的粉丝
  GetFans() {
    //

    this.$confirm(
      "选择确定全部更新粉丝（时间比较长），选择取消只更新新增粉丝！",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }
    )
      .then(async () => {
        this.GetFansFanion(1);
      })
      .catch(async () => {
        this.GetFansFanion(0);
      });
  }
  //同步粉丝方法
  async GetFansFanion(Code: any) {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      let IsloadingTwo = false;
      if (this.SelectFansDialog) {
        this.SelectFansDialog = false;
        IsloadingTwo = true;
      }
      this.loadingText = "数据正在同步中，请稍后.....";
      let params: any = {
        Input: [
          {
            Name: "FansUser",
            Value: {
              Aid: AppAccount.Aid,
              TenantID: AppAccount.TenantID,
              Code: Code
            }
          }
        ]
      };
      var res: any = await httpApi.FansSync(params);
      this.loading = false;
      if (IsloadingTwo) {
        this.SelectFansDialog = true;
      }
      if (res.ErrorCode == 0) {
        this.$message.success("同步粉丝成功");
      } else {
        this.$message.error("失败：" + res.ErrorMessage);
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //切换类型
  selectOne(val: any) {
    this.search = "";
    console.log(val);
    this.ReplyTextListData = [];
    this.ReplyImageListData = [];
    this.ReplyGraphicListData = [];
    this.ReplyVoiceListData = [];

    switch (val) {
      case 1:
        this.ReplyTextList();
        break;
      case 2:
        this.ReplyImageList();
        break;
      case 3:
        this.ReplyGraphicList();
        break;
      case 4:
        this.ReplyVoiceList(1);
        break;
      case 5:
        this.ReplyVoiceList(2);
        break;
      case 6:
        this.ReplyVoiceList(3);
        break;
    }
  }
  //加载文本关键词
  async ReplyTextList() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "aid",
            Value: AppAccount.Aid
          },
          {
            Name: "State",
            Value: 1
          }
        ]
      };
      var res: any = await httpApi.GetWxText(params);
      if (res.ErrorCode == 0) {
        var r = res.output[0].value;
        if (r) {
          this.ReplyTextListData = r;
          console.log(r);

          //this.AddaccountForm.txtImportFans.reload();
        }
      } else {
        this.$message.error("失败：" + res.ErrorMessage);
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //加载图片关键词
  async ReplyImageList() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "aid",
            Value: AppAccount.Aid
          },
          {
            Name: "State",
            Value: 1
          }
        ]
      };
      var res: any = await httpApi.GetImgText(params);
      if (res.ErrorCode == 0) {
        var r = res.output[0].value;
        if (r) {
          this.ReplyImageListData = r;
          //console.log(r);

          //this.AddaccountForm.txtImportFans.reload();
        }
      } else {
        this.$message.error("失败：" + res.ErrorMessage);
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //加载图文关键词
  async ReplyGraphicList() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "aid",
            Value: AppAccount.Aid
          },
          {
            Name: "Nature",
            value: 1
          },
          {
            Name: "State",
            Value: 1
          }
        ]
      };
      var res: any = await httpApi.GetWxImgText(params);
      if (res.ErrorCode == 0) {
        var r = res.output[0].value;
        if (r) {
          this.ReplyGraphicListData = r;
          //console.log(r);

          //this.AddaccountForm.txtImportFans.reload();
        }
      } else {
        this.$message.error("失败：" + res.ErrorMessage);
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //加载多媒体关键词
  async ReplyVoiceList(val: number) {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "aid",
            Value: AppAccount.Aid
          },
          {
            Name: "type",
            Value: val
          },
          // {
          //   Name: "nature",
          //   Value: 1
          // },
          // {
          //   Name: "ismediaid",
          //   Value: "yes"
          // },
          // {
          //   Name: "isGroup",
          //   Value: "yes"
          // },
          {
            Name: "State",
            Value: 1
          }
        ]
      };
      var res: any = await httpApi.Getvoid(params);

      if (res.ErrorCode == 0) {
        var r = res.output[0].value;
        if (r) {
          this.ReplyVoiceListData = r;
          // console.log(r);

          //this.AddaccountForm.txtImportFans.reload();
        }
      } else {
        this.$message.error("失败：" + res.ErrorMessage);
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //查看视频
  onViewVideo(param: any) {
    // if (param) {
    //   this.viewVideo = true;
    //   this.VoiceLink = param.VoiceLink;
    //   this.VoiceTitle = param.VoiceTitle;
    // }
    if (param) {
      var data = param.VoiceLink.split(".");
      if (data[data.length - 1] != "mp4") {
        window.open(param.VoiceLink, "newwin");
      } else {
        this.viewVideo = true;
        this.VoiceLink = param.VoiceLink;
        this.VoiceTitle = param.VoiceTitle;
      }
    } else {
      this.$message.error("视频地址失效");
    }
  }
  //获取选中数据
  getTemplateRow(val: any) {
    console.log(this.AddaccountForm.MsgType);
    console.log(val);
    switch (this.AddaccountForm.MsgType) {
      case 1:
        this.AddaccountForm.MsgId = val.TextId;
        this.AddaccountForm.MediaTile = val.Keyword;
        this.AddaccountForm.MediaId = "";
        this.AddaccountForm.Remarks = val.Remarks;
        break;
      case 2:
        this.AddaccountForm.MsgId = val.ImageId;
        this.AddaccountForm.MediaTile = val.Keyword;
        this.AddaccountForm.MediaId = val.MediaId;
        this.AddaccountForm.Remarks = val.Remarks;
        break;
      case 3:
        this.AddaccountForm.MsgId = val.GraphicId;
        this.AddaccountForm.MediaTile = val.Keyword;
        this.AddaccountForm.MediaId = val.MediaId;
        this.AddaccountForm.Remarks = val.Remarks;
        break;
      case 4:
      case 5:
        this.AddaccountForm.MsgId = val.VoiceId;
        this.AddaccountForm.MediaTile = val.VoiceTitle;
        this.AddaccountForm.MediaId = val.MediaId;
        this.AddaccountForm.Remarks = val.Description;
        break;
      case 99:
        if(!this.AddaccountForm.MsgId)
        this.AddaccountForm.MsgId = val.MaterialType;
        this.AddaccountForm.MediaTile = val.Keyword;
        this.AddaccountForm.MediaId = val.ID;
        this.AddaccountForm.Remarks = val.Description;
        break;
    }
    console.log(this.AddaccountForm);
    //this.templateSelection = row;
  }
  //格式化性别
  formatterSex(val: any) {
    console.log(val);

    switch (val.Sex) {
      case 2:
        return "女";
        break;
      case 1:
        return "男";
      default:
        return "未知";
        break;
    }
  }
  //对话框关闭
  handleDialogClose() {
    this.AddaccountForm.txtImportFans = "";
    this.ImportFansDialog = false;
  }
  // 加载列表
  async loadKeyReplyList() {
    let _this = this;
    let params: any = {
      Input: [
        {
          Name: "data",
          Value: {
            ApplicationID: _this.GetAppData.Aid,
            PageIndex: 1, // _this.currentPage,
            PageSize: 100, //_this.pageSize,
            KeyWord: _this.search,
            ActionName: 4
          }
        }
      ]
    };
    // _this.listLoading = true;
    let res: any = await httpApi.GetKeyReplyList(params);
    if (res.ErrorCode == 0) {
      _this.replyTotal = res.output[0].value.TotalCount;
      _this.replyList = res.output[0].value.lst.filter((data:any) => data.Status==1);
    } else {
      this.$message.error(res.ErrorMessage);
      console.log(res.ErrorMessage);
    }
    // _this.listLoading = false;
  }

  //加载粉丝数据
  loadData() {
    if (this.AddaccountForm.UserList) {
      this.inboxTabData = this.AddaccountForm.UserList.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
      this.paginationTotal = this.AddaccountForm.UserList.length;
    }
  }
  //切换省份
  async provideTrigger() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "FansAreaList",
            Value: {
              Aid: AppAccount.Aid,
              TenantID: AppAccount.TenantID,
              Code: "中国"
            }
          }
        ]
      };
      var res: any = await httpApi.Provides(params);
      // console.log(res);

      if (res.ErrorCode == 0) {
        var r = res.output[0].value;
        this.AreaList = r;
        r.forEach((e: { Province: any }) => {
          this.providetype.push({ label: e.Province, value: e.Province });
        });
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //切换城市
  async CityTrigger(val: string) {
    this.citytype = [];
    this.AddaccountForm.City = undefined;
    if (this.providetype && this.providetype != "") {
      var citylist = this.AreaList.filter(
        (x: { Province: string }) => x.Province == val
      )[0];
      if (citylist) {
        for (let index = 0; index < citylist.City.length; index++) {
          const element = citylist.City[index];
          this.citytype.push({ label: element, value: element });
        }
      }
    }
  }
  //选择发送时间
  changeIsSetSendDate(val: number) {
    if (val == 2) {
      this.SetSendDateShow = false;
      this.AddaccountForm.SetSendDate = new Date();
    } else {
      this.SetSendDateShow = true;
      //this.AddaccountForm.SetSendDate = "";
    }
  }
  //导入粉丝对话框
  ImportFans() {
    this.ImportFansDialog = true;
  }
  //增加粉丝
  AddFans() {
    this.FindFans = [];
    this.FindFansData = [];
    this.SelectFindFansData = [];
    this.SelectFansDialog = true;
  }
  //上传前验证文件
  onBeforeUploadImport(file: any) {
    const isIMAGE =
      file.type === "text/plain" ||
      "text/csv" ||
      "text/x-csv" ||
      "application/vnd.ms-excel" ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const isLt1M = file.size / 1024 / 1024 < 2;
    if (!isIMAGE) {
      this.$message.error("上传文件只能是txt、csv、xls、xlsx格式!");
      return;
    }
    if (!isLt1M) {
      this.$message.error("上传文件大小不能超过 2MB!");
      return;
    }
    return isIMAGE && isLt1M;
  }
  //上传文件
  UploadImport(param: any) {
    let reader = new FileReader();
    reader.readAsDataURL(param.file);
    var fileArray = param.file.name.split(".");
    if (fileArray.length == 2) {
      var Expansion = fileArray[1].toLowerCase();
      if (
        !(
          Expansion == "txt" ||
          Expansion == "csv" ||
          Expansion == "xls" ||
          Expansion == "xlsx"
        )
      ) {
        this.$message.error("请上传正确的文件格式!");
        return;
      }
    }
    reader.onload = async e => {
      if (e.target) {
        this.ImportFansDialog = false;
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.UploadImport(params);
        if (res.ErrorCode == 0) {
          var r = res.output[0].value;
          if (r) {
            this.AddaccountForm.txtImportFans = r;
            //this.AddaccountForm.txtImportFans.reload();
            this.ImportFansDialog = true;
          }
        } else {
          this.$message.error("导入失败：" + res.ErrorMessage);
        }
      }
    };
  }
  //查询数据
  async SearchData() {
    if (!(this.FindFans.NickName || this.FindFans.OpenID)) {
      this.$message.error("必须选一个查询条件!");
      return;
    }
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loadingTwo = true;
      let params: any = {
        Input: [
          {
            Name: "AppFansSelect",
            Value: {
              Aid: AppAccount.Aid,
              NickName: this.FindFans.NickName,
              OpenID: this.FindFans.OpenID,
              Sex: -1
            }
          }
        ]
      };
      var res: any = await httpApi.SarchFansList(params);
      this.loadingTwo = false;
      if (res.ErrorCode == 0) {
        var r = res.output[0].value;
        if (r.length == 0) {
          this.$message.error("没有查询到数据");
          return;
        }
        if (this.FindFansData) {
          r.forEach((element: any) => {
            if (
              this.FindFansData.filter(
                (d: { FansID: any }) => d.FansID == element.FansID
              ).length <= 0
            ) {
              this.FindFansData.push(element);
            }
          });
        } else {
          this.FindFansData = r;
        }
      } else {
        this.$message.error("失败：" + res.ErrorMessage);
      }
    }
  }
  //添加的粉丝重置
  Replacement() {
    this.FindFans = [];
  }
  //提交已经选中的粉丝
  async onSubmit() {
    if (!this.AddaccountForm.txtImportFans) {
      this.$message.error("请输入或导入Openid或Unionid！");
      return;
    }
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "OpenidOrUnionid",
            Value: this.AddaccountForm.txtImportFans
          },
          {
            Name: "aid",
            Value: AppAccount.Aid
          }
        ]
      };
      await httpApi.SarchOpenidOrUnionid(params).then((res: any) => {
        if (res.ErrorCode == 0) {
          var r = res.output[0].value;
          if (r) {
            //console.log(r);
            var result: any = [];
            if (this.AddaccountForm.UserList) {
              result = this.AddaccountForm.UserList;
            }
            r.forEach((x: any) => {
              if (
                result.filter((d: { FansID: any }) => d.FansID == x.FansID)
                  .length <= 0
              ) {
                result.push({
                  OpenID: x.OpenID,
                  NickName: x.NickName,
                  FansID: x.FansID
                });
              }
            });
            this.AddaccountForm.UserList = result;
            //console.log(this.AddaccountForm.UserList);
            this.loadData();
            this.ImportFansDialog = false;

            //console.log(JSON.stringify(result));
          }
        } else {
          this.$message.error("提取失败：" + res.ErrorMessage);
        }
      });
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //单行删除
  async handleDel(index: any, row: any) {
    this.$confirm("确定要删除当前粉丝吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      var index = this.AddaccountForm.UserList.findIndex(
        (x: { FansID: any }) => x.FansID == row.FansID
      );
      this.AddaccountForm.UserList.splice(index, 1);
      this.loadData();
    });
  }
  //选择粉丝页面删除
  async handleFindDel(index: any, row: any) {
    this.$confirm("确定要删除当前粉丝吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      var index = this.FindFansData.findIndex(
        (x: { FansID: any }) => x.FansID == row.FansID
      );
      this.FindFansData.splice(index, 1);
      this.FindFansData.refresh();
    });
  }
  //搜索粉丝
  handleSelectionChange(val: any) {
    this.SelectFindFansData = [];
    // console.log(val);
    this.SelectFindFansData = val;
  }
  //搜索粉丝确定方法
  SaveData() {
    var result: any = [];
    if (this.AddaccountForm.UserList) {
      result = this.AddaccountForm.UserList;
    }
    this.SelectFindFansData.forEach((x: any) => {
      if (
        result.filter((d: { FansID: any }) => d.FansID == x.FansID).length <= 0
      ) {
        result.push({
          OpenID: x.OpenID,
          NickName: x.NickName,
          FansID: x.FansID
        });
      }
    });
    this.AddaccountForm.UserList = result;
    //console.log(this.AddaccountForm.UserList);
    this.loadData();
    this.FindFans = [];
    this.FindFansData = [];
    this.SelectFindFansData = [];
    this.SelectFansDialog = false;
  }
  private handleSizeChange(val: any) {
    this.pageSize = val;
    this.loadData();
  }
  private handleCurrentChange(val: any) {
    this.currentPage = val;
    this.loadData();
  }
  createdData() {
    this.GetSarchTagsAsync();
    this.provideTrigger();
    this.selectOne(this.AddaccountForm.MsgType);
    this.changeIsSetSendDate(this.AddaccountForm.IsSetSendDate);
    this.loadData();
    this.loadKeyReplyList();
  }
  //初始化
  created() {
     this.scrollHeight = document.body.scrollHeight - 160;
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj: any) => {
      that.GetAppData.Aid = obj.Aid;
      that.createdData();
    });
    this.createdData();
  }
  //取消方法
  cancle() {
    this.$emit("refresh");
  }
  //保存数据
  async SavaTextData() {
    (this as any).$refs["AddaccountForm"].validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.loadingText = "数据正在提交中，请稍后.....";
        var _this = this;
        let AppAccount = this.GetAppData;
        if (AppAccount) {
          this.AddaccountForm.ApplicationId = AppAccount.Aid;
          this.AddaccountForm.TenantId = AppAccount.TenantID;
          this.AddaccountForm.SendStatus = 0;
          if (!this.AddaccountForm.Title) {
            this.$message.error("请输入群发标题！");
            return;
          }
          if (!this.AddaccountForm.SetSendDate) {
            this.$message.error("请选择发送时间！");
            return;
          }
          //保存的数据 传参
          if (this.AddaccountForm.GatherId) {
            this.AddaccountForm.ActionName = "UPDATE"; //修改方法
          } else {
            this.AddaccountForm.ActionName = "CREATE"; //新增方法
          }

          let params: any = {
            Input: [
              {
                Name: "AppSendMsgConfigDTO",
                value: this.AddaccountForm
              }
            ]
          };
          console.log(params);
          debugger;
          var res: any = await httpApi.SaveGroup(params);
          this.loading = false;
          if (res.ErrorCode == 0) {
            this.$message.success("保存成功!");
            //保存成功后传个刷新方法过去
            _this.$emit("refresh");
          } else {
            this.$message.error("保存失败：" + res.ErrorMessage);
          }
        }
      } else {
        this.$message.error("请认真填写必填项！");
      }
    });
  }
}
